import React from 'react';
import {Tag} from 'antd';

const StatusEstoque = ({status}) => {
    if(status == "SEPARADO"){
        return <Tag style={{ float:"right"}}>SEPARADO</Tag>
    }
    return <></>
}

export {StatusEstoque};